<template>
  <div class="main">
    <div ref="queryContent" v-sticky="{zIndex: 2001, stickyTop: 0, disabled: false}">
      <div class="header-wrapper">
        <el-form :disabled="isListLoading" :model="queryForm" ref="queryForm" :inline="true" label-width="0" :show-message="false">
          <div class="d-flex justify-content-between">
            <div class="filter-wrapper mr-2">
              <div class="filter-container">
                <div class="filter-item mr-3">
                  <label>任务类型：</label>
                  <el-form-item prop="taskType" class="inline-form-item">
                    <el-select v-model="queryForm.taskType" class="filter-input">
                      <el-option label="全部任务" :value="null"></el-option>
                      <el-option
                        v-for="item in taskTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>开始时间：</label>
                  <el-form-item prop="startTime" class="inline-form-item">
                    <el-date-picker
                      v-model="queryForm.startTime"
                      class="filter-input"
                      type="date"
                      format="yyyy/MM/dd"
                      value-format="yyyy-MM-dd"
                      :editable="false"
                      clearable
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>结束时间：</label>
                  <el-form-item prop="endTime" class="inline-form-item">
                    <el-date-picker
                      v-model="queryForm.endTime"
                      class="filter-input"
                      type="date"
                      format="yyyy/MM/dd"
                      value-format="yyyy-MM-dd"
                      :editable="false"
                      clearable
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="filter-item">
                  <el-form-item prop="displayByDate" class="inline-form-item">
                    <el-checkbox @change="changeDisplayByDate" v-model="queryForm.displayByDate">按日期展示</el-checkbox>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="tools flex-shrink-0">
              <div class="filter-item">
                <el-button :loading="isListLoading" :disabled="isExcelExporting" @click="fetchData" type="primary" class="query-button" icon="el-icon-search">查询</el-button>
                <el-button :disabled="isListLoading || isExcelExporting" @click="resetQueryForm" class="query-button">重置</el-button>
                <el-button :loading="isExcelExporting" :disabled="isListLoading" @click="exportExcel" type="warning" class="query-button">导出</el-button>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="main-content">
        <el-table
          ref="table"
          :data="rawListData"
          v-loading="isListLoading"
          border
          fit
          highlight-current-row
          style="width: 100%;"
          :max-height="tableMaxHeight">
          <el-table-column
            v-if="query.displayByDate"
            prop="Date"
            label="日期">
          </el-table-column>
          <el-table-column
            prop="DeployName"
            label="任务类型">
          </el-table-column>
          <el-table-column
            prop="Count"
            label="参与人数">
          </el-table-column>
          <el-table-column
            prop="Coin"
            label="发放健康币总数">
          </el-table-column>
        </el-table>
        <div class="text-center py-3">
          <el-pagination
            :disabled="isListLoading"
            @current-change="handleCurrentChange"
            @size-change="handlePageSizeChange"
            :current-page.sync="tableCurrentPage"
            :page-sizes="tablePageSizeOption"
            :page-size="tablePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableTotalSize"
            background>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'
import * as PointsStatsApi from '@/api/pointsStats'
import swal from 'sweetalert2'
import { deepClone } from '@/utils'
import exportExcel from '@/utils/exportExcel'
import moment from 'moment'

export default {
  name: 'points-stats',
  directives: {
    sticky: VueSticky
  },
  data() {
    const taskType = null
    const startTime = null
    const endTime = null
    const displayByDate = false

    return {
      queryForm: {
        // 任务类型
        taskType,
        // 开始时间
        startTime,
        // 结束时间
        endTime,
        // 按日期展示
        displayByDate
      },
      taskTypeList: [
        {
          id: '1',
          name: '每日签到'
        }, {
          id: '2',
          name: '共享秤称重'
        }, {
          id: '3',
          name: '阅读文章'
        }, {
          id: '4',
          name: '打开宝箱'
        }, {
          id: '5',
          name: '完善资料'
        }, {
          id: '6',
          name: '打开签到提醒'
        }, {
          id: '7',
          name: '查看积分商城'
        }, {
          id: '8',
          name: '兑换商品'
        }
      ],

      isListLoading: false,
      isExcelExporting: false,

      // 保存之前的请求参数
      query: deepClone({ taskType, startTime, endTime, displayByDate }),

      rawListData: [],

      // 表格当前页
      tableCurrentPage: 1,
      // 表格一页条数可选项
      tablePageSizeOption: [10, 20, 30],
      // 表格一页条数
      tablePageSize: 20,
      // 总条数
      tableTotalSize: 0,

      // 除表格外内容区域高度
      othersHeight: 0
    }
  },
  computed: {
    taskTypeMap() {
      return new Map(this.taskTypeList.map(item => [item.id, item.name]))
    },
    tableMaxHeight() {
      return Math.max(this.$store.getters.containerHeight - this.othersHeight, 300)
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
  },
  updated() {
    this.$nextTick(() => {
      const queryContent = this.$refs.queryContent
      const queryContentHeight = queryContent ? Math.round(queryContent.clientHeight) : 0
      this.othersHeight = queryContentHeight + 41 + 64
    })
  },
  methods: {
    // 重置查询
    resetQueryForm() {
      this.$refs.queryForm.resetFields()
    },
    changeDisplayByDate(value) {
      if (value && !this.queryForm.startTime && !this.queryForm.endTime) {
        const endTime = moment().format('YYYY-MM-DD')
        const startTime = moment(endTime).subtract(6, 'days').format('YYYY-MM-DD')
        this.$set(this.queryForm, 'startTime', startTime)
        this.$set(this.queryForm, 'endTime', endTime)
      }
    },
    fetchData() {
      const { startTime, endTime } = this.queryForm

      if (startTime && endTime && moment(startTime).isAfter(endTime)) {
        swal({
          text: '开始时间不能大于结束时间',
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
        return
      }

      // 克隆当前查询条件
      this.query = deepClone(this.queryForm)
      this.tableCurrentPage = 1
      this.tableTotalSize = 0

      this.fetchList()
    },
    fetchList() {
      this.isListLoading = true
      this.rawListData = []

      const { taskType, startTime, endTime, displayByDate } = this.query

      const postData = {
        deployId: taskType,
        Offset: (this.tableCurrentPage - 1) * this.tablePageSize,
        Limit: this.tablePageSize
      }
      startTime && (postData.startTime = startTime)
      endTime && (postData.endTime = endTime)
      displayByDate && (postData.showTime = displayByDate ? 1 : 0)

      PointsStatsApi.totalTask(postData).then(({ data }) => {
        this.isListLoading = false
        if (data.Status !== 200) {
          swal({
            text: data.Result.ErrorMsg,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }
        const rawListData = data.Result.List
        rawListData.forEach(item => {
          if (item.Days) {
            item.Date = moment(item.Days).format('YYYY-MM-DD')
          }
        })
        this.rawListData = rawListData
        this.tableTotalSize = parseInt(data.Result.Total) || 0
      }).catch(error => {
        swal({
          text: error.message,
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
        this.isListLoading = false
      })
    },
    handleCurrentChange(value) {
      this.fetchList()
    },
    handlePageSizeChange(value) {
      this.tableCurrentPage = 1
      this.tablePageSize = value
      this.fetchList()
    },
    exportExcel() {
      const { taskType, startTime, endTime, displayByDate } = this.queryForm

      if (startTime && endTime && moment(startTime).isAfter(endTime)) {
        swal({
          text: '开始时间不能大于结束时间',
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
        return
      }

      this.isExcelExporting = true
      const fileName = '积分数据统计'

      const postData = {
        deployId: taskType,
        Offset: 0,
        Limit: 9999
      }
      startTime && (postData.startTime = startTime)
      endTime && (postData.endTime = endTime)
      displayByDate && (postData.showTime = displayByDate ? 1 : 0)

      PointsStatsApi.totalTask(postData).then(({ data }) => {
        if (data.Status !== 200) {
          swal({
            text: data.Result.ErrorMsg,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          this.isExcelExporting = false
          return
        }
        const rawListData = data.Result.List
        rawListData.forEach(item => {
          if (item.Days) {
            item.Date = moment(item.Days).format('YYYY-MM-DD')
          }
        })

        let fields = {
          DeployName: '任务类型',
          Count: '参与人数',
          Coin: '发放健康币总数'
        }

        if (displayByDate) {
          fields = { Date: '日期', ...fields }
        }

        exportExcel([{ sheetName: fileName, data: rawListData }], fields, fileName)
        this.isExcelExporting = false
      }).catch(() => {
        this.isExcelExporting = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  display: table;
  table-layout: fixed;
  min-width: 1300px;
  width: 100%;
  height: 100%;
  background-color: #ececec;
  .filter-item {
    margin-bottom: 15px;
  }
  .filter-container {
    .filter-item {
      display: inline-block;
      white-space: nowrap;
    }
  }
  .filter-input {
    width: 200px;
  }
  .query-button {
    width: 100px;
  }
  .tool-button {
    width: 100px;
  }
  .oper-button {
    width: 80px;
  }
  .header-wrapper {
    padding: 14px 20px 0;
    box-shadow: 0 1px 3px rgba(0,0,0,.1);
    background-color: #fff;
  }
  .content-wrapper {
    padding: 20px;
    .main-content {
      border-top: 1px solid #e1e3e4;
      border-left: 1px solid #e1e3e4;
      border-right: 1px solid #e1e3e4;
      background-color: #fff;
      .button-wrapper {
        padding: 20px 20px;
      }
    }
  }
  .inline-form-item {
    display: inline-block;
    margin: 0;
    vertical-align: middle;
  }
}
</style>
